import React from 'react';
import { Grid } from 'semantic-ui-react';

import GridColumnInputWrapper from '../../../common/GridColumnInputWrapper';
import { AccordionWrapper } from 'react-lib/dist/components-es';
import CommonSelectInputWrapper from '../../../common/CommonSelectInputWrapper';
import connect from 'react-redux/es/connect/connect';
import { getRiskOptions } from '../../../../utils';
import { RISK_TYPE_LIQUID_CATEGORY_CODE } from '../../../../constants';
import { debounce } from 'lodash-es';
import { risksActions } from '../../../../behavior/risks';

class CPEnvironmentalInformationContainer extends React.Component {
  componentWillReceiveProps(newProps) {
    if (this.props.stateChange != newProps.stateChange) this.onStateChange(newProps);
  }

  onStateChange = props => {
    const stateId = props.values.chemicalProduct.state.id;
    if (stateId != 2) props.setFieldValue('chemicalProduct.liquidCategory', null);
  };

  render() {
    return (
      this.isLiquid(this.props.values) && (
        <AccordionWrapper
          {...this.props}
          closable={false}
          accordionTitle="chemical.product.details.page.environmental.inf.container.title"
          className="containerReducedWhiteSpace"
          render={this.getEnvironmentalInformationContainerContent}
        />
      )
    );
  }

  isLiquid = values => {
    return (
      values.chemicalProduct && values.chemicalProduct.state && values.chemicalProduct.state.id == 2
    );
  };

  debouncedEnvRiskCalculation = debounce(this.props.envRiskCalculation, 500);

  getEnvironmentalInformationContainerContent = () => {
    const { values, disabled, chemicalProductDisabled, initialData } = this.props;
    if (!values.chemicalProduct.liquidCategory) values.chemicalProduct.liquidCategory = {};

    return (
      <Grid stackable doubling columns={3} verticalAlign="bottom">
        <GridColumnInputWrapper
          {...this.props}
          key="liquidCategory.id"
          value={values.chemicalProduct.liquidCategory.id || ''}
          name="chemicalProduct.liquidCategory.id"
          label={'chemical.product.details.page.environmental.inf.container.liquid.category.input'}
          options={getRiskOptions(
            initialData.riskList,
            RISK_TYPE_LIQUID_CATEGORY_CODE,
            values.chemicalProduct.liquidCategory
          )}
          placeholder="select.input.default.placeholder"
          disabled={disabled || chemicalProductDisabled}
          onChange={this.debouncedEnvRiskCalculation}
          specialRequiredCondition={true}
          tooltipClassName="ultraWideTooltip"
          render={props => <CommonSelectInputWrapper {...props} />}
        />
      </Grid>
    );
  };
}

const mapStateToProps = state => ({
  stateChange: state.chemicalProducts.stateChange
});

const mapDispatchToProps = dispatch => ({
  envRiskCalculation: () => dispatch(risksActions.envRiskCalculation())
});

export default connect(mapStateToProps, mapDispatchToProps)(CPEnvironmentalInformationContainer);
